import type { EngineDocument, SceneNode } from "../scene/model";
import type { RenderImages } from "./canvas-surface";
import { renderCanvas } from "./canvas-surface";
import { bounds } from "../native/geometry";
import { hasEffects } from "../native/effects";
import { effectBounds } from "./native-effects-raster";
import { NativeCanvasRenderer } from "./native-canvas";
export function rasterBox(node: SceneNode) {
  const b = hasEffects(node) ? effectBounds(node) : bounds(node);
  const pad =
    node.kind === "text"
      ? 12
      : node.kind === "path"
        ? Math.max(12, (node.appearance.strokeWidth ?? 3) * 5)
        : 2;
  return {
    x: Math.floor(b.x - pad),
    y: Math.floor(b.y - pad),
    width: Math.ceil(b.width + pad * 2),
    height: Math.ceil(b.height + pad * 2),
  };
}
export function paintRaster(
  document: EngineDocument,
  node: SceneNode,
  density: number,
  images: RenderImages,
) {
  const box = rasterBox(node);
  const scale = Math.min(
    density,
    8192 / box.width,
    8192 / box.height,
    Math.sqrt(16_000_000 / (box.width * box.height)),
  );
  const canvas = renderCanvas(),
    renderer = new NativeCanvasRenderer(canvas, images);
  renderer.draw(
    {
      document,
      camera: { x: -box.x * scale, y: -box.y * scale, zoom: scale },
      width: Math.max(1, Math.round(box.width * scale)),
      height: Math.max(1, Math.round(box.height * scale)),
      dpr: 1,
    },
    true,
    new Set([node.id]),
  );
  return { canvas, box };
}
